import { Card, CardBody, CardHeader, CardHeading, Empty } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EventBudgetAnalyticsCostResource } from "../analyticsTypes";
import { CostPerCurrency } from "./CostPerCurrency";

const OverviewRow = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(2)};

	${({ theme }) => theme.breakpoints.desktop} {
		grid-template-columns: 1fr 1fr;
	}
`;

const GridCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

const EmptyCardBody = styled(CardBody)`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 300px;
`;

interface Props {
	totalEventCosts: EventBudgetAnalyticsCostResource[];
	averageCostsPerEvent: EventBudgetAnalyticsCostResource[];
}

export function CostsOverview({ totalEventCosts, averageCostsPerEvent }: Props) {
	const { t } = useTranslation();
	return (
		<OverviewRow>
			<Card>
				<CardHeader>
					<CardHeading>{t("Total costs")}</CardHeading>
				</CardHeader>
				{totalEventCosts.length === 0 && (
					<EmptyCardBody>
						<Empty>{t("No data is available.")}</Empty>
					</EmptyCardBody>
				)}
				{totalEventCosts.length > 0 && (
					<GridCardBody>
						{totalEventCosts.map((costs, index) => (
							<CostPerCurrency key={index} costsWithCurrency={costs} />
						))}
					</GridCardBody>
				)}
			</Card>
			<Card>
				<CardHeader>
					<CardHeading>{t("Average cost per event")}</CardHeading>
				</CardHeader>
				{averageCostsPerEvent.length === 0 && (
					<EmptyCardBody>
						<Empty>{t("No data is available.")}</Empty>
					</EmptyCardBody>
				)}
				{averageCostsPerEvent.length > 0 && (
					<GridCardBody>
						{averageCostsPerEvent.map((costs, index) => (
							<CostPerCurrency key={index} costsWithCurrency={costs} />
						))}
					</GridCardBody>
				)}
			</Card>
		</OverviewRow>
	);
}
